import '../assets/NcAppNavigationSettings-BDc6Mtek.css';
import { createElementBlock, openBlock, mergeProps, createElementVNode, createCommentVNode, toDisplayString, defineComponent, ref, useTemplateRef, computed, normalizeClass, createVNode, unref, withCtx, createTextVNode, Transition, withDirectives, renderSlot, vShow } from "vue";
import { onClickOutside } from "@vueuse/core";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { r as register, a as t } from "./_l10n-dinIMiE_.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
import { N as NcButton } from "./NcButton-Byg8-ta1.mjs";
register();
const _sfc_main$1 = {
  name: "CogIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
const _hoisted_1$1 = ["aria-hidden", "aria-label"];
const _hoisted_2 = ["fill", "width", "height"];
const _hoisted_3 = { d: "M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" };
const _hoisted_4 = { key: 0 };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", mergeProps(_ctx.$attrs, {
    "aria-hidden": $props.title ? null : "true",
    "aria-label": $props.title,
    class: "material-design-icon cog-icon",
    role: "img",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }), [
    (openBlock(), createElementBlock("svg", {
      fill: $props.fillColor,
      class: "material-design-icon__svg",
      width: $props.size,
      height: $props.size,
      viewBox: "0 0 24 24"
    }, [
      createElementVNode("path", _hoisted_3, [
        $props.title ? (openBlock(), createElementBlock("title", _hoisted_4, toDisplayString($props.title), 1)) : createCommentVNode("", true)
      ])
    ], 8, _hoisted_2))
  ], 16, _hoisted_1$1);
}
const IconCog = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render]]);
const _hoisted_1 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppNavigationSettings",
  props: {
    excludeClickOutsideSelectors: { default: () => [] },
    name: { default: () => t("Settings") }
  },
  setup(__props) {
    const contentId = createElementId();
    const open = ref(false);
    const container2 = useTemplateRef("wrapperElement");
    const ignore = computed(
      () => Array.isArray(__props.excludeClickOutsideSelectors) ? __props.excludeClickOutsideSelectors : __props.excludeClickOutsideSelectors.split(" ")
    );
    onClickOutside(container2, () => {
      open.value = false;
    }, { ignore });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: "wrapperElement",
        class: normalizeClass(_ctx.$style.container)
      }, [
        createElementVNode("div", {
          class: normalizeClass(_ctx.$style.header)
        }, [
          createVNode(NcButton, {
            "aria-controls": unref(contentId),
            "aria-expanded": open.value ? "true" : "false",
            onClick: _cache[0] || (_cache[0] = ($event) => open.value = !open.value)
          }, {
            icon: withCtx(() => [
              createVNode(IconCog, { size: 20 })
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(_ctx.name), 1)
            ]),
            _: 1
          }, 8, ["aria-controls", "aria-expanded"])
        ], 2),
        createVNode(Transition, {
          "enter-active-class": _ctx.$style.animationActive,
          "leave-active-class": _ctx.$style.animationActive,
          "enter-from-class": _ctx.$style.animationStop,
          "leave-to-class": _ctx.$style.animationStop
        }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              id: unref(contentId),
              class: normalizeClass(_ctx.$style.content)
            }, [
              renderSlot(_ctx.$slots, "default")
            ], 10, _hoisted_1), [
              [vShow, open.value]
            ])
          ]),
          _: 3
        }, 8, ["enter-active-class", "leave-active-class", "enter-from-class", "leave-to-class"])
      ], 2);
    };
  }
});
const container = "_container_1v0ql_2";
const header = "_header_1v0ql_7";
const content = "_content_1v0ql_12";
const animationActive = "_animationActive_1v0ql_24";
const animationStop = "_animationStop_1v0ql_30";
const style0 = {
  container,
  header,
  content,
  animationActive,
  animationStop
};
const cssModules = {
  "$style": style0
};
const NcAppNavigationSettings = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAppNavigationSettings as N
};
//# sourceMappingURL=NcAppNavigationSettings-aTOqq_-d.mjs.map
